<template>
  <div>
<!--    <a-input ref="userNameInput" v-model="keyWords" placeholder="请输入商品名称或编号">-->
<!--      <a-icon slot="prefix" type="filter"/>-->
<!--    </a-input>-->
    <div style="height: 400px;overflow-y: auto">
      <a-list :data-source="filterGoods">
        <a-list-item slot="renderItem" slot-scope="item">
          <a slot="actions" @click="choiceGoods(item)">
            <span v-if="target.indexOf(item.id) === -1 ">选中</span>
            <a-icon
              style="color: #2eb67d"
              v-if="!(target.indexOf(item.id) === -1) || item.id === goodsId"
              type="check"/>
          </a>
          <a-list-item-meta
          >
            <a slot="title">{{ item.name }}-{{ item.code }}</a>
            <a-avatar
              slot="avatar"
              :src="item.coverPath"
            />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>

<script>
import { _queryGoods } from '@/api/goodsApi';

export default {
  name: 'ImgGoodsSelectCheckbox',
  props: {
    type: String,
    status: String,
    goodsId: String,
    // value: Array,
  },
  data() {
    return {
      form: {
        visible: false,
        data: {
          name: '',
        },
      },
      table: {
        data: [],
      },
      options: [],
      target: [],
    };
  },
  watch: {
    // currentValue(val) {
    //   this.$emit('input', val);
    // },
    // value(i) {
    //   this.currentValue = val;
    // },
  },
  computed: {
    filterGoods() {
      return this.options.filter(x => (
        this.keyWords ? (x.name.toUpperCase().includes(this.keyWords.toUpperCase()) ||
          x.code.toUpperCase().includes(this.keyWords.toUpperCase())) : true));
    },
  },
  methods: {
    choiceGoods(item) {
      if (!(this.target.indexOf(item.id) === -1)) {
        const index = this.target.indexOf(item.id);
        this.target.splice(index, 1);
        this.goodsId = '';
      } else {
        this.target.push(item.id);
        this.$emit('confirm', this.target);
      }
      this.form.visible = false;
    },
    openSearchForm() {
      this.form.visible = true;
      this.form.data.name = '';
    },
    onValueChange() {
    },
    async searchGoods() {
      if (this.form.data.name) {
        const result = await _queryGoods({ name: this.form.data.name });
        this.table.data = result.content
          .filter(x => (this.status ? x.status === this.status : true))
          .filter(x => (this.type ? x.type === this.type : true));
      }
    },
  },
  async created() {
    const result = await _queryGoods({ name: this.form.data.name });
    this.options = result.content
      .filter(x => (this.status ? x.status === this.status : true))
      .filter(x => (this.type ? x.type === this.type : true));

    if (this.goodsId) {
      this.target.push(this.goodsId);
    }
  },
};
</script>

<style scoped>
.goods-wrap {
  height: 400px;
  overflow-y: auto;
}

.goods-item {
  margin: 10px 5px;
  cursor: pointer;
}

.goods-item:hover {
  color: #00A8CC;
}

</style>
